import { $api } from "../../../store/api/api";

import { EndpointsEnum } from "../../../constants/endpoints";

import { IPostTicketRoomMessageBody, IPostTicketRoomMessage, IPostTicketRoomMessageResponse } from "./post-ticket-room-message.types";
import { IRestResponse } from "../../../types/response";

export const postTicketRoomMessage: IPostTicketRoomMessage = async (body: IPostTicketRoomMessageBody) => {
    const response = await $api.post<IRestResponse<IPostTicketRoomMessageResponse>>(`${EndpointsEnum.POST_TICKET_ROOM_MESSAGE}`, body);

    return response.data;
};
